/**
 * ThresholdSettings.jsx — Gestão dos thresholds de alerta.
 * Permite editar os dias que definem cada tipo de alerta.
 */

import React, { useEffect, useState } from "react";
import { fetchConfiguracoes, updateConfiguracao } from "../../services/api";

const CAMPOS = [
  {
    chave: "threshold_aprovacao_externa",
    label: "Dias em Aprovação Externa antes de alerta",
    descricao: "Tarefas neste bucket há mais dias que este valor aparecem nos Bottlenecks.",
  },
  {
    chave: "threshold_aguardo_info",
    label: "Dias em Aguardo Informações antes de alerta",
    descricao: "Tarefas em Aguardo há mais dias que este valor são sinalizadas.",
  },
  {
    chave: "threshold_sem_update",
    label: "Dias sem actividade antes de considerar abandonada",
    descricao: "Tarefas que não mudaram de bucket há este número de dias surgem como 'sem update'.",
  },
];

export default function ThresholdSettings() {
  const [valores, setValores] = useState({});
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState({});
  const [feedback, setFeedback] = useState({});

  useEffect(() => {
    fetchConfiguracoes()
      .then((configs) => {
        const mapa = {};
        configs.forEach((c) => { mapa[c.chave] = c.valor; });
        setValores(mapa);
      })
      .finally(() => setLoading(false));
  }, []);

  const guardar = async (chave) => {
    setGuardando((prev) => ({ ...prev, [chave]: true }));
    setFeedback((prev) => ({ ...prev, [chave]: null }));
    try {
      await updateConfiguracao(chave, valores[chave]);
      setFeedback((prev) => ({ ...prev, [chave]: { tipo: "ok", msg: "Guardado." } }));
    } catch (e) {
      setFeedback((prev) => ({ ...prev, [chave]: { tipo: "erro", msg: e.message } }));
    } finally {
      setGuardando((prev) => ({ ...prev, [chave]: false }));
    }
  };

  if (loading) return <p style={styles.loading}>A carregar configurações…</p>;

  return (
    <div style={styles.grid}>
      {CAMPOS.map(({ chave, label, descricao }) => (
        <div key={chave} style={styles.card}>
          <label style={styles.label}>{label}</label>
          <p style={styles.descricao}>{descricao}</p>
          <div style={styles.inputRow}>
            <input
              style={styles.input}
              type="number"
              min="1"
              max="365"
              value={valores[chave] ?? ""}
              onChange={(e) =>
                setValores((prev) => ({ ...prev, [chave]: e.target.value }))
              }
            />
            <span style={styles.unidade}>dias</span>
            <button
              style={styles.btn}
              onClick={() => guardar(chave)}
              disabled={guardando[chave]}
            >
              {guardando[chave] ? "A guardar…" : "Guardar"}
            </button>
          </div>
          {feedback[chave] && (
            <p style={feedback[chave].tipo === "ok" ? styles.ok : styles.erro}>
              {feedback[chave].msg}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}

const styles = {
  grid: { display: "flex", flexDirection: "column", gap: 20 },
  card: { background: "#fff", borderRadius: 8, padding: 24, boxShadow: "0 1px 3px rgba(0,0,0,.08)" },
  label: { display: "block", fontSize: 15, fontWeight: 600, color: "#1e293b", marginBottom: 4 },
  descricao: { fontSize: 13, color: "#64748b", margin: "0 0 16px" },
  inputRow: { display: "flex", alignItems: "center", gap: 10 },
  input: { width: 80, padding: "8px 12px", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 16, fontWeight: 600, textAlign: "center" },
  unidade: { fontSize: 14, color: "#64748b" },
  btn: { padding: "8px 20px", backgroundColor: "#6366f1", color: "#fff", border: "none", borderRadius: 6, fontSize: 13, cursor: "pointer", fontWeight: 600 },
  ok: { fontSize: 12, color: "#16a34a", margin: "8px 0 0" },
  erro: { fontSize: 12, color: "#dc2626", margin: "8px 0 0" },
  loading: { color: "#64748b" },
};
